(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('store-google-reviews-five-star')) return;

    // One Maps loader per page; reuse a theme's existing Maps installation.
    let mapsReady;
    const withTimeout = (promise, milliseconds) =>
      new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Google connection timed out')), milliseconds);
        Promise.resolve(promise).then(
          (value) => {
            clearTimeout(timer);
            resolve(value);
          },
          (error) => {
            clearTimeout(timer);
            reject(error);
          }
        );
      });

    function loadMaps(key, language) {
      if (window.google?.maps?.importLibrary) return Promise.resolve();
      if (mapsReady) return mapsReady;
      mapsReady = new Promise((resolve, reject) => {
        const existing = [...document.scripts].find((script) => {
          try {
            const url = new URL(script.src);
            return /^(maps\.googleapis\.com|maps\.google\.com)$/.test(url.hostname) && url.pathname === '/maps/api/js';
          } catch {
            return false;
          }
        });
        if (existing) {
          // A different theme component may have inserted Maps moments earlier.
          const started = Date.now();
          const interval = setInterval(() => {
            if (window.google?.maps?.importLibrary) {
              clearInterval(interval);
              resolve();
            } else if (Date.now() - started > 15000) {
              clearInterval(interval);
              reject(new Error('Existing Google Maps loader is unavailable'));
            }
          }, 100);
          return;
        }
        // Dynamic Library Import: load only when importLibrary is first called.
        // Google replaces this temporary importLibrary function when ready.
        const google = (window.google ||= {});
        const maps = (google.maps ||= {});
        const libraries = new Set();
        let bootstrap;
        maps.importLibrary = (name, ...args) => {
          libraries.add(name);
          bootstrap ||= Promise.resolve().then(
            () =>
              new Promise((ready, failed) => {
                maps.__sgr5Ready = ready;
                const url = new URL('https://maps.googleapis.com/maps/api/js');
                url.search = new URLSearchParams({
                  key,
                  v: 'weekly',
                  loading: 'async',
                  callback: 'google.maps.__sgr5Ready',
                  libraries: [...libraries].join(','),
                  language: language || 'en',
                }).toString();
                const script = document.createElement('script');
                script.src = url.href;
                script.async = true;
                script.nonce = document.querySelector('script[nonce]')?.nonce || '';
                script.onerror = () => failed(new Error('Google Maps could not load'));
                document.head.append(script);
              })
          );
          return bootstrap.then(() => maps.importLibrary(name, ...args));
        };
        resolve();
      });
      return mapsReady;
    }

    // Google-provided logo, unmodified, from the official attribution asset pack.
    const GOOGLE_MAPS_LOGO =
      'data:image/png;base64,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';
    const textNode = (tag, className, text = '') => {
      const node = document.createElement(tag);
      node.className = className;
      node.textContent = typeof text === 'string' ? text : String(text);
      return node;
    };
    const httpsURL = (value) => {
      if (typeof value !== 'string') return null;
      try {
        const url = new URL(value);
        return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
      } catch {
        return null;
      }
    };
    const linkNode = (className, label, url) => {
      const href = httpsURL(url);
      const node = textNode(href ? 'a' : 'span', className, label);
      if (href) {
        node.href = href;
        node.target = '_blank';
        node.rel = 'noopener noreferrer';
      }
      return node;
    };

    function renderFiveStarReviews(place, placeId) {
      // Strict equality is intentional: never round up 4.9 or accept missing ratings.
      const reviews = (Array.isArray(place.reviews) ? place.reviews : []).filter((review) => review?.rating === 5);
      const listingURL =
        httpsURL(place.googleMapsURI) ||
        'https://www.google.com/maps/search/?api=1&query=red.&query_place_id=' + encodeURIComponent(placeId);
      const widget = textNode('div', 'sgr5__widget');
      const brand = textNode('div', 'sgr5__brand');
      const logo = document.createElement('img');
      logo.className = 'sgr5__logo';
      logo.alt = 'Google Maps';
      logo.src = GOOGLE_MAPS_LOGO;
      brand.append(logo);
      widget.append(brand, textNode('p', 'sgr5__selection', 'Selected five-star reviews · ranked by Google relevance'));
      const scroll = textNode('div', 'sgr5__scroll');
      scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', 'Selected five-star Google reviews');
      const summary = textNode('div', 'sgr5__summary');
      if (place.displayName) summary.append(textNode('h3', 'sgr5__business-name', place.displayName));
      if (typeof place.rating === 'number' && Number.isFinite(place.rating) && place.rating >= 1 && place.rating <= 5) {
        let label = 'Overall Google rating: ' + place.rating + ' / 5';
        if (Number.isInteger(place.userRatingCount) && place.userRatingCount >= 0)
          label += ' from ' + place.userRatingCount.toLocaleString() + ' ratings';
        summary.append(textNode('p', 'sgr5__overall-rating', label));
      }
      scroll.append(summary);
      for (const review of reviews) {
        const article = textNode('article', 'sgr5__review');
        article.setAttribute('aria-label', 'Five-star Google review');
        const author = review.authorAttribution || {};
        const byline = textNode('div', 'sgr5__author');
        const photo = httpsURL(author.photoURI);
        if (photo) {
          const avatar = document.createElement('img');
          avatar.className = 'sgr5__avatar';
          avatar.alt = '';
          avatar.width = 36;
          avatar.height = 36;
          avatar.loading = 'lazy';
          avatar.referrerPolicy = 'no-referrer';
          avatar.src = photo;
          byline.append(avatar);
        }
        const authorInfo = textNode('div', 'sgr5__author-info');
        authorInfo.append(linkNode('sgr5__author-name', author.displayName || 'Google reviewer', author.uri));
        if (review.relativePublishTimeDescription)
          authorInfo.append(textNode('span', 'sgr5__date', review.relativePublishTimeDescription));
        byline.append(authorInfo);
        const stars = textNode('p', 'sgr5__stars', '★★★★★');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', '5 out of 5 stars');
        article.append(byline, stars);
        if (review.text) {
          const body = textNode('p', 'sgr5__review-text', review.text);
          if (/^[a-z]{2,3}(?:-[a-zA-Z0-9]{2,8})*$/.test(review.textLanguageCode || ''))
            body.lang = review.textLanguageCode;
          article.append(body);
        }
        if (httpsURL(review.googleMapsURI))
          article.append(linkNode('sgr5__review-link', 'Read review on Google Maps ↗', review.googleMapsURI));
        scroll.append(article);
      }
      // Never substitute lower-star reviews if Google's returned selection has no fives.
      if (!reviews.length) scroll.append(textNode('p', 'sgr5__empty', 'Explore more reviews on Google Maps.'));
      widget.append(scroll);
      const footer = textNode('div', 'sgr5__footer');
      footer.append(linkNode('sgr5__all-link', 'See all Google reviews ↗', listingURL));
      for (const attribution of place.attributions || []) {
        if (typeof attribution === 'string') footer.append(textNode('span', 'sgr5__provider', attribution));
        else if (attribution?.provider)
          footer.append(linkNode('sgr5__provider', attribution.provider, attribution.providerURI));
      }
      widget.append(footer);
      return widget;
    }

    class StoreGoogleFiveStarReviews extends HTMLElement {
      connectedCallback() {
        if (this.started || this.observer) return;
        // Shopify can attach the element before its child markup has been parsed.
        this.frame = requestAnimationFrame(() => this.prepare());
      }

      prepare() {
        if (!this.isConnected) return;
        if (!this.dataset.apiKey || !this.dataset.placeId) {
          if (this.dataset.editor !== 'true') this.hidden = true;
          return;
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              this.observer = null;
              this.start();
            }
          });
          this.observer.observe(this);
        } else {
          this.start();
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.observer = null;
        clearTimeout(this.loadTimer);
        // Discard an unfinished component so a moved/reconnected section can retry.
        if (!this.loaded) {
          this.started = false;
          this.generation = (this.generation || 0) + 1;
          this.querySelector('.sgr5__mount')?.replaceChildren();
        }
      }

      async start() {
        if (this.started || !this.isConnected) return;
        this.started = true;
        this.failed = false;
        const generation = this.generation || 0;
        const current = () => this.isConnected && generation === (this.generation || 0);
        const status = this.querySelector('.sgr5__status');
        const mount = this.querySelector('.sgr5__mount');
        if (!status || !mount) return;
        mount.setAttribute('aria-busy', 'true');

        const fail = () => {
          if (!current()) return;
          clearTimeout(this.loadTimer);
          this.failed = true;
          mount.replaceChildren();
          mount.setAttribute('aria-busy', 'false');
          status.hidden = false;
          status.textContent = this.dataset.failureLabel || 'Reviews are available on Google Maps.';
          if (this.dataset.editor === 'true') {
            status.textContent +=
              ' Check the Place ID, API key, domain restrictions, billing, Maps JavaScript API and Places API (New).';
          }
        };

        try {
          await withTimeout(loadMaps(this.dataset.apiKey, this.dataset.language), 20000);
          const { Place } = await withTimeout(window.google.maps.importLibrary('places'), 15000);
          if (!current()) return;
          const place = new Place({ id: this.dataset.placeId });
          await withTimeout(
            place.fetchFields({
              fields: ['reviews', 'rating', 'userRatingCount', 'displayName', 'googleMapsURI'],
            }),
            20000
          );
          if (!current()) return;
          const widget = renderFiveStarReviews(place, this.dataset.placeId);
          mount.replaceChildren(widget);
          this.loaded = true;
          mount.setAttribute('aria-busy', 'false');
          status.hidden = true;
        } catch {
          fail();
        }
      }
    }
    customElements.define('store-google-reviews-five-star', StoreGoogleFiveStarReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
